import React from 'react';
import FeatherIcon from 'feather-icons-react';

import Logo from '../../../assets/hp-logo.png';

import './footer.scss';

const Footer = () => {
  const utm = '?utm_source=quotes-hc-tool&utm_medium=links&utm_campaign=quotes-hc-tool';
  return (
    <div id="footer">
      <div className="container">
        <div className="sections row">
          <div className="col-6 col-md-2">
            <img src={Logo} alt="logo-white.svg" className="logo tw-fill-current tw-text-green" />
          </div>
          <div className="col-6 col-md-2">
            <h3>Let&apos;s Connect</h3>
            <ul className="links">
              <li>
                <a href="" target="_blank">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="tel:+919769891528">Call +91 9769891528</a>
              </li>
              <li>
                <a href="">contact@hipcouch.com</a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2">
            <h3>About</h3>
            <ul className="links">
              <li>
                <a rel="noreferrer" href={`https://www.hipcouch.com/about?${utm}`} target="_blank">
                  Our Story
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  href={`https://www.hipcouch.com/hipcouch-in-the-news${utm}`}
                  target="_blank"
                >
                  Press
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  href={`https://www.hipcouch.com/our-designers${utm}`}
                  target="_blank"
                >
                  Designers
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2">
            <h3>Design Services</h3>
            <ul className="links">
              <li>
                <a
                  rel="noreferrer"
                  href={`https://www.hipcouch.com/magazine${utm}`}
                  target="_blank"
                >
                  Get Inspired
                </a>
              </li>
              <li>
                <a href="#questionnaire" target="_blank">
                  Get an Estimate
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2">
            <h3>Manufacturers</h3>
            <ul className="links">
              <li>
                <a rel="noreferrer" href={`https://www.hipcouch.com/faqs${utm}`} target="_blank">
                  FAQ&apos;s
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  href={`https://www.hipcouch.com/privacy-policy${utm}`}
                  target="_blank"
                >
                  Privacy
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  href={`https://www.hipcouch.com/post-lockdown-measures-faqs${utm}`}
                  target="_blank"
                >
                  Our COVID-19 Safety Measures
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-2">
            <h3>Social</h3>
            <ul className="social">
              <li>
                <a rel="noreferrer" href="https://www.facebook.com/hipcouch" target="_blank">
                  <FeatherIcon icon="facebook" />
                </a>
              </li>
              <li>
                <a rel="noreferrer" href="https://www.instagram.com/hipcouch/" target="_blank">
                  <FeatherIcon icon="instagram" />
                </a>
              </li>
            </ul>
            <p>© 2024 All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Footer };
